import { ToastsStore } from "react-toasts";


export const setToast = (type = 'success', msg = '') => ToastsStore[type](msg);
